export default {
  computed: {
    baseSystemStatuses () {
      return this.$store.getters.getSystemSetting('appointment_statuses')
    }
  },
  methods: {
    baseStatusOptions (withAll = false, withUnscheduled = true) {
      const arr = []
      if (withAll) {
        arr.push({
          value: null,
          label: 'All Appointments',
          hex_color: '#000'
        })
      }
      if (withUnscheduled) {
        arr.push({
          value: 'UNSCHEDULED',
          label: this.baseFieldName('UNSCHEDULED'),
          hex_color: this.baseFieldColor('UNSCHEDULED')
        })
      }
      arr.push(
        {
          value: 'CANCELLED',
          label: this.baseFieldName('CANCELLED'),
          hex_color: this.baseFieldColor('CANCELLED')
        },
        {
          value: 'UNCONFIRMED',
          label: this.baseFieldName('UNCONFIRMED'),
          hex_color: this.baseFieldColor('UNCONFIRMED')
        },
        {
          value: 'SCHEDULED',
          label: this.baseFieldName('SCHEDULED'),
          hex_color: this.baseFieldColor('SCHEDULED')
        },
        {
          value: 'DEPARTED',
          label: this.baseFieldName('DEPARTED'),
          hex_color: this.baseFieldColor('DEPARTED')
        },
        {
          value: 'IN_PROGRESS',
          label: this.baseFieldName('IN_PROGRESS'),
          hex_color: this.baseFieldColor('IN_PROGRESS')
        },
        {
          value: 'COMPLETE',
          label: this.baseFieldName('COMPLETE'),
          hex_color: this.baseFieldColor('COMPLETE')
        },
        {
          value: 'DEPARTED_INCOMPLETE',
          label: this.baseFieldName('DEPARTED_INCOMPLETE'),
          hex_color: this.baseFieldColor('DEPARTED_INCOMPLETE')
        }
      )
      return arr
    },
    baseStatusSettings (status) {
      return this.baseSystemStatuses[status]
    },
    baseFieldColor (status) {
      return this.company.appointment_status_colors[status] || '#757575'
    },
    defaultRunsheetFilterState () {
      return ['SCHEDULED', 'IN_PROGRESS', 'DEPARTED']
    },
    defaultFilterState () {
      return ['UNCONFIRMED', 'SCHEDULED', 'IN_PROGRESS', 'CANCELLED', 'DEPARTED', 'COMPLETE', 'DEPARTED_INCOMPLETE']
    },
    baseFieldName (status) {
      return this.baseStatusSettings(status).name
    }
  }
}
